// extracted by mini-css-extract-plugin
module.exports =  {"imageFigure":"jut__Image__imageFigure","imageFigureCaption":"jut__Image__imageFigureCaption","imageFigureLoading":"jut__Image__imageFigureLoading"};